<template>
      <div no-body class="lku-apinv"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="6">
          <b-input-group>
              <b-input-group-prepend><label>Asset ID</label></b-input-group-prepend>
              <b-form-input v-model="tblData.asetid" @keyup.13.native="refresh()" size="sm" placeholder="(% for wildcard)"></b-form-input>
              <b-form-input v-model="tblData.nomorpo" @keyup.13.native="refresh()" size="sm" placeholder="Purch.Order#" class="ml-1"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Asset Name</label></b-input-group-prepend>
              <b-form-input v-model="tblData.asdesc" size="sm" @keyup.13.native="refresh()"></b-form-input>                                       
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
              <b-input-group-prepend><label>Category</label></b-input-group-prepend>
                <b-form-input v-model="tblData.catgname" @keyup.13.native="refresh()" size="sm" :disabled="((tblData.catgid ||'') !== '')"></b-form-input>
                <b-form-input v-model="tblData.asserial" @keyup.13.native="refresh()" size="sm" placeholder="Serial Number" class="ml-1"></b-form-input>
          </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>PIC/User</label></b-input-group-prepend>
              <b-form-input v-model="tblData.asuser" placeholder="User" @keyup.13.native="refresh()"></b-form-input>
              <b-input-group-append>
                  <b-button size="sm" class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button size="sm" class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblFixAsset" style="font-size:smaller;" 
          responsive small striped hover
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(asdatacq)="data">
          {{data.item.asdatacq| moment('D-MMM-YY')}} 
        </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-apinv {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import fixedasset from "../../apis/fixedasset";

export default {
  data() {
    return {
      lkuLoading:false,
      fields: [
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name/Description",
            sortable: true
          },
          {
            key: "asmodel",
            label: "Model/Type",
            sortable: true
          },
          {
            key: "asserial",
            label: "S/N",
            sortable: true
          },
          {
            key: "asdatacq",
            thStyle: "width:80px",
            label: "Acquisition",
            sortable: true
          },
          {
            key: "nomorpo",
            label: "Reference Doc.",
            sortable: true
          },
          {
            key: "catgname",
            label: "Category/Group",
            sortable: true
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'asetid',
        sortDesc: false,
        outstand : '1'
      },
      updatetable:false
    };
  },
  computed: {
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },
  props: ["catgid","catgname","outstand","formdata"],
  created: async function() {
     this.tblData.catgid=this.catgid;
     this.tblData.catgname=this.catgname;
      this.tblData.outstand=this.outstand || '';
        if (this.formdata.items)
        {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
        } else {
          this.data();
        }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    clearFilter(ctx) {
        this.tblData.catgname = '';
        this.tblData.nomorpo=  '';
        this.tblData.asdesc=  '';
        this.tblData.asetid=  '';
        this.tblData.asserial=  '';
        this.tblData.asuser=  '';
        this.refresh();
    },    
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await fixedasset.list(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items=list;
      this.updatetable=!this.updatetable;
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblFixAsset.refresh();
       }
    },    
    refresh() {
      this.data();
      this.$refs.tblFixAsset.refresh();
    }
  }
};
</script>
